var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('BmiForm',{attrs:{"form-data":_vm.additionalDetails.bmi,"prefix":'member' + _vm.memberIndex}}),_c('SupplementaryQuestionForm',{attrs:{"additional-details":_vm.additionalDetails,"prefix":'family-member' + _vm.memberIndex}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }